import React, { Children } from 'react';
/**
 * Helper function to find the first MenuItem ID in the content
 */
export const findFirstMenuItemId = (content, MenuItemGroup, MenuItem) => {
    const children = Children.toArray(content);
    for (const child of children) {
        if (React.isValidElement(child)) {
            if (child.type === MenuItemGroup) {
                // Look for the first MenuItem in this group
                const groupChildren = Children.toArray(child.props.children);
                for (const groupChild of groupChildren) {
                    if (React.isValidElement(groupChild) && groupChild.type === MenuItem) {
                        const label = groupChild.props.label || '';
                        return groupChild.props.id || `${label.toLowerCase().replace(/\s+/g, '-')}`;
                    }
                }
            }
            else if (child.type === MenuItem) {
                // Direct MenuItem (not in a group)
                const label = child.props.label || '';
                return child.props.id || `${label.toLowerCase().replace(/\s+/g, '-')}`;
            }
        }
    }
    return null;
};
/**
 * Helper function to build a flat list of all menu items organized by groups
 */
export const buildMenuItemsMap = (content, MenuItemGroup, MenuItem) => {
    const children = Children.toArray(content);
    const groups = [];
    let currentGroupIndex = 0;
    children.forEach((child) => {
        if (React.isValidElement(child)) {
            if (child.type === MenuItemGroup) {
                const groupChildren = Children.toArray(child.props.children);
                const items = [];
                groupChildren.forEach((groupChild) => {
                    if (React.isValidElement(groupChild) && groupChild.type === MenuItem) {
                        const label = groupChild.props.label || '';
                        const itemId = groupChild.props.id || `${label.toLowerCase().replace(/\s+/g, '-')}`;
                        items.push(itemId);
                    }
                });
                if (items.length > 0) {
                    groups.push({ groupIndex: currentGroupIndex, items });
                    currentGroupIndex++;
                }
            }
            else if (child.type === MenuItem) {
                // Direct MenuItem (treat as its own group)
                const label = child.props.label || '';
                const itemId = child.props.id || `${label.toLowerCase().replace(/\s+/g, '-')}`;
                groups.push({ groupIndex: currentGroupIndex, items: [itemId] });
                currentGroupIndex++;
            }
        }
    });
    return groups;
};
